import { render } from "./ArtistsSkeleton.vue?vue&type=template&id=5e2f5ac2"
const script = {}

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__